import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Box, IconButton, Logo } from '@miro-site/core';
import theme from './theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var highContrastBgColors = ['dark', 'workshops-color-indigo', 'workshops-color-blue', 'workshops-color-red'];
var headerHeight = {
  height: [68, 92, 92, 92]
};
var Header = styled(Box).attrs(function (_ref) {
  var $background = _ref.$background;
  return {
    as: 'header',
    $styles: {
      background: $background,
      position: 'absolute',
      left: 0,
      right: 0
    }
  };
}).withConfig({
  displayName: "AcquisitionHeader__Header",
  componentId: "sc-1i5dc36-0"
})([""]);
var HeaderContainer = styled(Box).attrs({
  $styles: {
    width: [null, null, null, 1680],
    boxSizing: 'content-box'
  },
  $mx: 'auto',
  $px: [20, null, null, 60]
}).withConfig({
  displayName: "AcquisitionHeader__HeaderContainer",
  componentId: "sc-1i5dc36-1"
})(["", ""], function (props) {
  return props.theme.mq.medium({
    paddingLeft: "".concat(40 / 12, "vw"),
    paddingRight: "".concat(40 / 12, "vw")
  });
});
var HeaderWrapper = styled(Box).attrs({
  $styles: _objectSpread(_objectSpread({}, headerHeight), {}, {
    position: 'relative'
  })
}).withConfig({
  displayName: "AcquisitionHeader__HeaderWrapper",
  componentId: "sc-1i5dc36-2"
})([""]);
var LogoWrapper = styled(IconButton).attrs({
  $styles: {
    position: 'absolute',
    top: [12, 25, 25, 25],
    left: 0
  }
}).withConfig({
  displayName: "AcquisitionHeader__LogoWrapper",
  componentId: "sc-1i5dc36-3"
})([""]);
var HeaderSpacer = styled(Box).attrs({
  $styles: _objectSpread({}, headerHeight)
}).withConfig({
  displayName: "AcquisitionHeader__HeaderSpacer",
  componentId: "sc-1i5dc36-4"
})([""]);

var AcquisitionHeader = function AcquisitionHeader(props) {
  var _props$background = props.background,
      background = _props$background === void 0 ? 'white' : _props$background;
  return /*#__PURE__*/_jsxs(ThemeProvider, {
    theme: function theme(defaultTheme) {
      return _objectSpread(_objectSpread({}, defaultTheme), {}, {
        multipliers: {
          small: function small(value) {
            return "".concat(value / 3.65, "vw");
          },
          mediumUp: function mediumUp(value) {
            return "".concat(value, "px");
          },
          mediumDown: function mediumDown(value) {
            return "".concat(value / 12, "vw");
          },
          large: function large(value) {
            return "".concat(value, "px");
          }
        }
      });
    },
    children: [/*#__PURE__*/_jsx(Header, {
      $background: theme.background[background],
      children: /*#__PURE__*/_jsx(HeaderContainer, {
        children: /*#__PURE__*/_jsx(HeaderWrapper, {
          children: /*#__PURE__*/_jsx(LogoWrapper, {
            icon: /*#__PURE__*/_jsx(Logo, {
              $styles: {
                width: 89,
                height: 32,
                color: highContrastBgColors.includes(background) ? 'primaryWhite' : 'primaryIndigo'
              }
            }),
            label: "Miro Logo",
            href: "/",
            title: "Go to the main page"
          })
        })
      })
    }), /*#__PURE__*/_jsx(HeaderSpacer, {})]
  });
};

export default AcquisitionHeader;